// extracted by mini-css-extract-plugin
export default {"eventList":"SearchResultPanelContentEventCardList-module__eventList___1YEh_"};